var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg4Icon32PxCamera(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.53 11.15c-.31-.179-.69-.179-1 0L21 12.89c-.06-1.614-1.385-2.891-3-2.89H9c-1.657 0-3 1.343-3 3v6c0 1.657 1.343 3 3 3h9c1.615.001 2.94-1.276 3-2.89l3.56 1.78c.136.07.287.108.44.11.187 0 .37-.051.53-.15.293-.183.47-.504.47-.85v-8c0-.346-.177-.667-.47-.85zM19 19c0 .552-.448 1-1 1H9c-.552 0-1-.448-1-1v-6c0-.552.448-1 1-1h9c.552 0 1 .448 1 1v6zm5-.62l-3-1.5v-1.76l3-1.5v4.76z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg4Icon32PxCamera);
export default __webpack_public_path__ + "static/media/4-icon-32-px-camera.e2a603f0.svg";
export { ForwardRef as ReactComponent };